import { useMemo } from 'react';

import { trackChange, trackClick, trackEvent, trackInput } from './index';

/**
 * Thin React glue over the already-tested `trackEvent`/`trackClick`/`trackInput`/`trackChange`
 * functions, for components that need to fire custom events (or a click/input/change not covered
 * by `data-analytics-id` / `<TrackClick>`) from inside event handlers or effects.
 *
 * HIPAA: `props`/ids passed through must be opaque ids/enums only — never free text or PHI.
 *
 * @public Documented public API of the analytics module (see analytics/README.md); intentionally
 * exported for component consumers even though no call site exists in-repo yet.
 */
export function useTrackEvent() {
  return useMemo(() => ({ trackEvent, trackClick, trackInput, trackChange }), []);
}
